import { ReactNode } from "react";
import styled from "styled-components";

type ButtonProps = {
  text: string;
  onClick: (e?: React.FormEvent) => void;
  icon?: ReactNode;
  width?: string;
  margin?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  backgroundColor?: string;
  color?: string;
  padding?: string;
  withHover?: boolean;
};

const Button = ({
  text,
  onClick,
  icon,
  width,
  margin,
  type,
  disabled,
  backgroundColor,
  color,
  padding,
  withHover = true,
}: ButtonProps) => {
  return (
    <StyledButton
      disabled={disabled}
      type={type}
      onClick={onClick}
      width={width}
      margin={margin}
      backgroundColor={backgroundColor}
      color={color}
      padding={padding}
      withHover={withHover}
    >
      {icon}
      {text}
    </StyledButton>
  );
};

const StyledButton = styled.button<{
  width?: string;
  margin?: string;
  backgroundColor?: string;
  color?: string;
  padding?: string;
  withHover?: boolean;
}>`
  width: ${({ width }) => width || "100%"};
  margin: ${({ margin }) => margin || "auto"};
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor || theme.colors.primary};
  padding: ${({ padding }) => padding || "10px 15px"};
  border: none;
  border-radius: ${({ theme }) => theme.radii.default};
  color: ${({ theme, color }) => color || theme.colors.dark};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  font-size: ${({ theme }) => theme.fontSize.Button};
  cursor: pointer;
  transition: background-color 0.2s linear;
  transition: opacity 0.2s linear;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;

  svg {
    width: 20px;
  }

  ${({ withHover, backgroundColor, theme }) =>
    withHover &&
    `
  &:hover {
    background-color: ${backgroundColor || theme.colors.primaryDark};
    opacity: ${backgroundColor && "0.6"};
  }
  `}

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export default Button;
